import { Navigate } from 'react-router-dom';
import type { ReactElement } from 'react';
import { getUser } from '@/utils/auth';

interface ProtectedRouteProps {
  element: ReactElement;
  allowedRoles?: number[];
}

export default function ProtectedRoute({
  element,
  allowedRoles,
}: ProtectedRouteProps) {
  const token = localStorage.getItem('token');
  const user = getUser();

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(Number(user.role))) {
    return <Navigate to="/login" replace />;
  }

  return element;
}
